import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config";
import { OauthModel } from "../model/oauth.model";
import storage from "../storage";
import TokenService from "./token.service";
import apiConfig from "../api-config";



const instanceGPT = axios.create({
  baseURL: config.chat_gpt.base_url,
  headers: {
    "Content-Type": "application/json",
  },
})

const instanceGPTRefresh = axios.create({
  baseURL: config.authen.api.host_url,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

instanceGPT.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken() || TokenService.getHR9AccessToken() ;
    if (token) {
      // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      config.headers["scoutout-authorization"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    alert("กรุณา Login ใหม่");
    window.open('/authen')
    return Promise.reject(error);
  }
);

instanceGPT.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    if (originalConfig.url !== apiConfig.authen.token && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instanceGPTRefresh.post(apiConfig.authen.token, {
            grant_type: 'refresh_token',
            refresh_token: TokenService.getLocalRefreshToken(),
          });
          const token = rs.data as OauthModel
          TokenService.updateLocalAccessToken(token.access_token);

          return instanceGPT(originalConfig);
        } catch (_error) {
        
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instanceGPT;